module.exports = __webpack_public_path__ + "static/media/privacy-black-icon.421ef801.svg";